import React from 'react'
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { getFacilitiesDataPointEnergy, start } from '../../store/slices/FacilitiesSlice';
import { useEffect } from 'react';
import fetchApi from '../../services/fetch-data.service';
import { Breadcrumb, Dropdown, Form } from 'react-bootstrap';
import EnergyData from './EnergyData';
import useFetch from '../../hooks/useFetch';



export default function EnergyManagement() {
  const today = new Date();
  const Currmonth = today.getMonth() + 1;
  const Currryear = today.getFullYear();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [month, setMonth] = useState(Currmonth);
  const [year, setYear] = useState(Currryear);
  const [statedata, setStateData] = useState(useLocation().state)
  const [isMounted, setIsMounted] = useState(true)
  const [datas, setDatas] = useState()
  //const years = Array.from({ length: 10 }, (_, index) => Currryear - index);


  // const facilityId = useSelector((state) => state.facilities.data.facilityid)
  const { data, isLoading } = useFetch(`facilities/profile/${statedata ? statedata.stateid.id : ""}`);

  const options = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  const years = [
    { value: "2025", label: "2025" },
    { value: "2024", label: "2024" },
    { value: "2023", label: "2023" },
    { value: "2022", label: "2022" },
    { value: "2021", label: "2021" },
    { value: "2020", label: "2020" },
    { value: "2019", label: "2019" },
    { value: "2018", label: "2018" },
    { value: "2017", label: "2017" },
    { value: "2016", label: "2016" },
    { value: "2015", label: "2015" },
    { value: "2014", label: "2014" },
  ];

  useEffect(() => {

    const fetchData = async (statedata, month, year, isMounted) => {
      try {
        const res = await fetchApi(`facilities/datapoint/${statedata ? statedata.id : ""}
          ?month=${month}&year=${year}&facility_id=${statedata.stateid.id}`);
        if (isMounted && res.status === 200) {
          if (res.data.data && Object.keys(res.data.data).length > 0) {
            dispatch(getFacilitiesDataPointEnergy(res.data.data));
            setDatas(res.data.data)
            setIsMounted(false)
          } else (
            dispatch(start())
          )
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(statedata, month, year, isMounted);

  }, [statedata, month, year, isMounted]);

  const goBack = () => {
    navigate(-1);
  }

  const handleChange = (e) => {
    setMonth(e.target.value);
    //setYear(Currryear);
    setIsMounted(true)
  };
  const handleYearChange = (e) => {
    setYear(e.target.value);
    //setYear(Currryear);
    setIsMounted(true)
  };

  const generateLink = (subCategory) => {
    switch (subCategory) {
      case 'GHG Emissions':
        return '/assetanalyticdetail';
      case 'Air Quality':
        return '/airquality';
      case 'Energy Management':
        return '/energymanagement';
      case 'Water & Wastewater Management':
        return '/watermanagement';
      case 'Waste & Hazardous Materials Management':
        return '/hazardousmanagement';
      default:
        return '/defaultLink';
    }
  };

  return (
    <>
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2 float-start">
            <Link onClick={goBack}>
              <i className="fa-solid fa-arrow-left"></i>
            </Link>
          </h1>
          <Breadcrumb className="breadcrumb-inner">
            <Breadcrumb.Item><Link to="/assets">Assets</Link></Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link onClick={goBack}> {statedata.stateid.name} </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{statedata.displayName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="FacilityAnalyticdetails">
          <div className="firstrowadetails">
            <div className="left-content">
              <h4>  {statedata.stateid.name}</h4>
              {/* <Dropdown>
                                <Dropdown.Toggle variant="link" id="dropdown-first">
                                    BMW Head office
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown> */}
            </div>
            <div className="rightcontent">
              <Dropdown>
                <Dropdown.Toggle variant="link" id="dropdown-first">
                  {statedata.displayName}
                </Dropdown.Toggle>

                <Dropdown.Menu defaultOpen={false}>
                  {data && data.length > 0
                    ? data.map((val, idx) => (
                      <Dropdown.Item key={idx}>
                        <Link
                          to={{
                            pathname: generateLink(val.sub_category),

                          }}
                          state={{ id: val.id, subCategoryName: val.sub_category, displayName: val.display_name, stateid: statedata.stateid }}
                        >
                          {val.display_name}
                        </Link>
                      </Dropdown.Item>
                    ))
                    : ''}
                </Dropdown.Menu>
              </Dropdown>
               <div className="yeardropdownfirstrow">
                              <Form.Select aria-label="Default select example" onChange={handleChange} value={month}>
                                {options.map((option) => (
                                  <option value={option.value} key={option.value}>{option.label}</option>
                                ))}
                              </Form.Select>
                            </div>
                            <div className="yeardropdownfirstrow">
                              <Form.Select aria-label="Default select example" onChange={handleYearChange} value={year}>
                                {years.map((option) => (
                                  <option value={option.value} key={option.value}>{option.label}</option>
                                ))}
                              </Form.Select>
                            </div>

              {/*<Dropdown>
                <Dropdown.Toggle variant="link" drop="start" id="dropdown-last">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1"> <i class="fa-solid fa-download"></i> Download CSV Template</Dropdown.Item>
                  <Dropdown.Item href="#/action-2"> <i class="fa-solid fa-upload"></i> Upload CSV</Dropdown.Item>
                  <Dropdown.Item href="#/action-3"> <i class="fa-solid fa-file-excel"></i> Upload Excel</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>*/}
            </div>
          </div>

          {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
          {datas && Object.keys(datas).length > 0 ? (
            Object.keys(datas).map((key, idx) => {
              return (
                <div key={idx}>
                  <h4 className='tabletitle'>{key}</h4>
                  <table className="table goal-details">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Input</th>
                        <th>Unit</th>
                        <th>Attachments</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <EnergyData month={month} year={year} facility_id={statedata.stateid.id} setIsMounted={setIsMounted} keys={key} />
                    </tbody>
                  </table>
                </div>
              )
            })
          ) : (
            <tr>
              <td colSpan="6">No data available.</td>
            </tr>
          )}
        </div>
      </main>
    </>
  )
}
